import { useCallback, useRef } from 'react';
import { usePanelCommands } from '../../../ui/hooks/usePanelCommands';
import type { AttributesPanelValues, AttributesSaveInput, AttributesSavedInput } from '../types';

export function useAttributesPanelSave() {
    const { dispatch } = usePanelCommands();
    const latestSave = useRef(0);
    const saveAttributes = useCallback(
        async (values: AttributesPanelValues, isDeletingAttribute: boolean) => {
            const saveVersion = ++latestSave.current;
            const result = await dispatch<AttributesSaveInput, string | undefined>('attributes.save', {
                values,
                isDeletingAttribute
            });
            if (result.status !== 'ok' || !result.value || saveVersion !== latestSave.current) {
                return undefined;
            }
            const savedId = result.value;
            const notification = await dispatch<AttributesSavedInput>('attributes.saved', {
                entityId: savedId,
                isDeletingAttribute
            });
            if (notification.status === 'superseded' || saveVersion !== latestSave.current) return undefined;
            return savedId;
        },
        [dispatch]
    );
    return saveAttributes;
}
